export class StringUtil {
  /**
   *
   * @param str                       input string
   * @param maxLength                 maximum output length
   * @param withEllipsis              indicate missing text with ellipsis
   * @param searchRangeWordBoundary   cut inside a word if seaerchiong for Boundary get longer than this (-1 for never)
   */
  static truncateWord(
    str: string,
    maxLength: number,
    withEllipsis = false,
    searchRangeWordBoundary = -1
  ) {
    if (str.length > maxLength) {
      const ellipsisLength = withEllipsis ? 3 : 0
      const len = maxLength - ellipsisLength
      const result = StringUtil.truncateAtLastWordBoundary(
        str.substr(0, len + 1),
        searchRangeWordBoundary
      )
      return (result.length > len ? result.substr(0, len) : result) + (withEllipsis ? '...' : '')
    }
    return str
  }

  /**
   * Cuts at last word boundary
   * @param str
   * @param searchRange
   * @private
   */
  static truncateAtLastWordBoundary(str, searchRange = 0) {
    const truncateRegExp = new RegExp(`\\s+\\S{0,${searchRange > 0 ? searchRange : ''}}$`)
    return str.replace(truncateRegExp, '')
  }
}
